"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeResource = exports.Resource = void 0;

var PIXI = _interopRequireWildcard(require("pixi.js"));

var _hooks = require("../hooks");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
} //#region fix fuck type


var Resource = PIXI.LoaderResource;
exports.Resource = Resource;
var Polygon = PIXI.Polygon; //#endregion

var makeResource = {
  maker: undefined,
  draw: function draw(object) {
    var close = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _hooks.defaultClose;

    if (this.maker == null) {
      this.maker = new PIXI.Renderer({
        width: 0,
        height: 0,
        transparent: true
      });
      console.warn('[Furegame]: used `makeResource` to generate temporary resources, not recommand for production envriroments.'); // eslint-disable-line no-console
    }

    var maker = this.maker; // lazy init the maker once it was used.

    var _object$getBounds = object.getBounds(),
        width = _object$getBounds.width,
        height = _object$getBounds.height; // renderer the object


    maker.view.width = width;
    maker.view.height = height;
    maker.render(object); // generate texture

    var image = new Image();
    image.src = maker.view.toDataURL();
    var texture = new PIXI.Texture(new PIXI.BaseTexture(image)); // clean the renderer

    maker.clear();
    maker.view.width = 0;
    maker.view.height = 0;
    close(object);
    return function (id, loader) {
      if (id) {
        if (loader) {
          var resource = new Resource(id, "#".concat(id));
          loader.resources[id] = resource;
          resource.texture = texture;
        }

        PIXI.Texture.addToCache(texture, id);
      }

      return texture;
    };
  },
  shape: function shape() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        fill = _ref.fill,
        line = _ref.line;

    var border = line && line.width ? 2 * line.width : 0;
    return {
      draw: function draw(shape) {
        var graphics = new PIXI.Graphics();
        fill ? graphics.beginFill(fill.color, fill.alpha) : graphics.beginFill(0x000000);
        line && graphics.lineStyle(line.width, line.color, line.alpha);

        if (shape instanceof Function) {
          shape(graphics);
        } else {
          graphics.drawShape(shape);
        }

        return makeResource.draw(graphics);
      },
      circle: function circle(radius) {
        return this.draw(new PIXI.Circle(border + radius, border + radius, radius));
      },
      ellipse: function ellipse(width, height) {
        return this.draw(new PIXI.Ellipse(border + width, border + height, width, height));
      },
      polygon: function polygon(points) {
        return this.draw(new Polygon(points));
      },
      rectangle: function rectangle(width, height) {
        return this.draw(new PIXI.Rectangle(border, border, width, height));
      },
      roundedRectangle: function roundedRectangle(width, height, radius) {
        return this.draw(new PIXI.RoundedRectangle(border, border, width, height, radius));
      },
      triangle: function triangle(width, height, sharp) {
        return this.draw(new Polygon([border + sharp, border, border, border + height, border + width, border + height]));
      },
      star: function star(points, radius, innerRadius, rotation) {
        return this.draw(function (graphics) {
          return graphics.drawStar(border + radius, border + radius, points, radius, innerRadius, rotation);
        });
      }
    };
  },
  text: function text(value, style) {
    return makeResource.draw(new PIXI.Text(value, style));
  }
};
exports.makeResource = makeResource;